exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".step-policy-row {\n  padding: 5px 0;\n  border-bottom: 1px solid var(--color-seashell);\n}\n", ""]);

